<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="reload()"
        class="query-form"
    >
      <el-form-item label="出口发票号：">
        <el-input v-model="dataForm.receiptCode" placeholder="出口发票号" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="外销合同号：">
        <order-drop v-model="dataForm.agreementCode"></order-drop>
      </el-form-item>
      <el-form-item label="品番号：">
        <el-input v-model="dataForm.code" placeholder="品番号" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="SKU：">
        <el-input v-model="dataForm.skuCode" placeholder="SKU" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="品名：">
        <el-input v-model="dataForm.name" placeholder="品名" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="颜色：">
        <el-input v-model="dataForm.color" placeholder="颜色" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="规格：">
        <el-input v-model="dataForm.size" placeholder="规格" size="mini" clearable></el-input>
      </el-form-item>
      <el-form-item label="装船日期：">
        <el-date-picker
            v-model="dateArr"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="mini"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发货工厂：">
        <company v-model="dataForm.factoryId" :clearable="true"></company>
      </el-form-item>
      <el-form-item label="是否开票：">
        <el-select v-model="dataForm.isOpen" size="mini" clearable>
          <el-option value="" label="全部"></el-option>
          <el-option value="Y" label="已开票"></el-option>
          <el-option value="N" label="未开票"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="$refs.table.reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="tool-box">
      <el-button type="primary" size="mini" @click="doExport()">
        导出EXCEL
      </el-button>
      <!--      <el-button type="primary" :disabled="true" size="mini" v-if="$hasPermission('box:change_factory')" @click="showChangeFactory">-->
      <!--        调整发货厂-->
      <!--      </el-button>-->
      <!--      <el-button-->
      <!--          size="mini"-->
      <!--          icon="el-icon-upload"-->
      <!--          @click="$refs.appendBoxUpload.init()"-->
      <!--          type="warning"-->
      <!--          v-if="$hasPermission('send:batch:append')"-->
      <!--      >箱单补录-->
      <!--      </el-button>-->
      <el-button type="danger" size="mini" v-if="$hasPermission('box:detail:del')" @click="doBatchDelete">
        批量删除
      </el-button>
      <el-button type="warning" size="mini" v-if="$hasPermission('box:detail:price')" @click="editPrice">
        调整单价
      </el-button>
    </div>
    <SweetTable ref="table" url="/erp/box/detail/page" :summaries-column="['totalCount','amount']"
                :query-form="dataForm" :cell-style="cellStyleHandler"
                row-key="detailId" :before-table-binding="beforeTableBinding" api-version="v2" :selection="true">
      <el-table-column
          prop="receiptCode"
          label="出口发票号"
          header-align="center"
          align="center"
          width="120"
      ></el-table-column>
      <el-table-column
          prop="shipDate"
          label="装船日期"
          header-align="center"
          align="center"
          width="100"
      ></el-table-column>
      <el-table-column
          label="外销合同号"
          prop="agreementCode"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column label="品番号" prop="product.code" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="SKU" prop="product.skuCode" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="品名" prop="product.name" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="颜色" prop="product.color" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="规格" prop="product.size" align="center" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
          label="出货数量"
          prop="totalCount"
          align="center"
          width="100"
      >
      </el-table-column>
      <el-table-column
          label="销售单价"
          prop="price"
          align="center"
          width="80"
      >
      </el-table-column>
      <el-table-column
          label="出货工厂"
          prop="factoryName"
          align="center"
          width="160"
          :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column prop="boxCount" label="箱数" header-align="center" align="center"></el-table-column>
      <el-table-column prop="preBoxCount" label="入数" header-align="center" align="center"></el-table-column>
      <el-table-column prop="totalCount" label="总数" header-align="center" align="center"></el-table-column>
      <el-table-column prop="totalSize" label="总体积" header-align="center" align="center"></el-table-column>
      <el-table-column prop="weight" label="毛重" header-align="center" align="center"></el-table-column>
      <el-table-column prop="preSize" label="单箱体积" header-align="center" align="center"></el-table-column>
      <el-table-column prop="boxLong" label="长" header-align="center" align="center"></el-table-column>
      <el-table-column prop="boxWidth" label="宽" header-align="center" align="center"></el-table-column>
      <el-table-column prop="boxHeight" label="高" header-align="center" align="center"></el-table-column>
            <el-table-column
                label="操作"
                header-align="center"
                align="center"
                width="100"
                fixed="right"
            >
              <template #default="{row}">
                <el-button
                    type="text"
                    size="small"
                    v-if="$hasPermission('box:reduce')"
                    @click="showReduceDialog(row)"
                >冲减
                </el-button>
              </template>
            </el-table-column>
    </SweetTable>
    <PriceDialog ref="priceDialogRef" @changed="()=>{getDataList();clearSelection();}"></PriceDialog>
    <ChangeFactory ref="ChangeFactory" @refreshDataList="()=>{getDataList();clearSelection();}"></ChangeFactory>
    <EditCountDialog ref="EditCountDialog" @complete="getDataList"></EditCountDialog>
    <ReduceDialog ref="reduceDialogRef" @complete="getDataList"></ReduceDialog>

    <common-upload
        ref="appendBoxUpload"
        @success="getDataList"
        uploadUrl="/erp/box/import/append"
        templateUrl="/static/template/发货批量导入.xlsx"
        title="箱单补录"
        version="v2"
    ></common-upload>
  </div>

</template>

<script>
import ReduceDialog from '@/views/modules/erp/box/reduce-dialog.vue'
import PriceDialog from '@/views/modules/erp/box/price-dialog.vue'
import EditCountDialog from '@/views/modules/erp/box/edit-count-dialog.vue'
import BigNumber from 'bignumber.js'
import ChangeFactory from '@/views/modules/box-form/ChangeFactory.vue'
import SweetTable from '@/mixins/SweetTable'

export default {
  mixins: [SweetTable],
  components: { ChangeFactory, EditCountDialog, PriceDialog, ReduceDialog },
  data () {
    return {
      dateArr: [],
      dataForm: {
        agreementCode: '',
        receiptCode: '',
        beginDate: '',
        endDate: '',
        formType: 'outlet',
        code: '',
        skuCode: '',
        name: '',
        color: '',
        size: '',
        factoryId: '',
        isOpen: ''
      },
    }
  },
  watch: {
    dateArr (newVal) {
      if (newVal && newVal.length === 2) {
        this.dataForm.beginDate = newVal[0]
        this.dataForm.endDate = newVal[1]
      } else {
        this.dataForm.beginDate = ''
        this.dataForm.endDate = ''
      }
      this.currentId = ''
      this.$refs.table.reload()
    },
  },
  methods: {
    cellStyleHandler({ row, column, cellValue, columnIndex }) {
      if(row.totalCount<0){
        return {
          color: 'red'
        }
      }
    },
    editPrice () {
      let dataList = this.$refs[this.tableRef].dataListSelections
      if (this.$c.isArrayEmpty(dataList)) {
        return this.$message.error('请选择要调整的数据')
      }
      this.$refs.priceDialogRef.open(dataList.map(item => item.id))
    },
    doExport () {
      this.$export(`/erp/box/detail/export`, this.dataForm, null, 'v2')
    },
    doBatchDelete () {
      let dataList = this.$refs[this.tableRef].dataListSelections
      if (this.$c.isArrayEmpty(dataList)) {
        return this.$message.error('请选择要删除的数据')
      }
      this.$confirm('确定要删除选中的数据吗？箱单明细删除后会解绑关联的库存记录,请及时核对工厂收发货情况！', '提示').then(() => {
        this.$api2.post(`/erp/box/detail/del`, { ids: dataList.map(item => item.id) }).then(res => {
          this.$message.success('删除成功')
          this.clearSelection()
          this.getDataList()
        })
      })
    },
    showEditCountDialog (row) {
      console.log('showEditCountDialog', row)
      this.$refs.EditCountDialog.init(row)
    },
    showReduceDialog (row) {
      this.$refs.reduceDialogRef.init(row)
    },
    showChangeFactory () {
      let dataList = this.$refs[this.tableRef].dataListSelections
      if (this.$c.isArrayEmpty(dataList)) {
        return this.$message.error('请选择要调整的数据')
      }
      this.$refs.ChangeFactory.ids = dataList.map(item => item.id)
      this.$refs.ChangeFactory.init()
    },
    addOrUpdateHandle () {
      this.$router.push(`/trade/box-form/save`)
    },
    beforeTableBinding (dataList) {
      dataList.forEach(row => {
        row.amount = new BigNumber(row.price || 0).multipliedBy(row.totalCount).toFixed(3)
      })
    }
  },
}
</script>
